import apiClient from "./client";

export const cookiePolicyServices = {
  getByToken: () => apiClient.get("/policies/cerez-politikasi"),
};
